/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Review/view.blocks to change it.
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Review({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/OldAction/Action/ActionButton/Review"
  
}) {
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 marginLeft="auto"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Review"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}